import React from 'react';
import { getGroupsList } from '../../../../models/groups';
import i18n from '../../../../i18n';
import { formatDate } from '../../../../utils/common';
import StatusBadge from '../../../common/StatusBadge';
import { AUCTION_STATUS } from '../../../../constants/status';
import HeaderBanner from '../../../common/HeaderBanner';
import { SideBar } from '../../sidebar';
import FilterSection from '../../../common/Filter';
import Select from 'react-select';
import { selectStyles } from '../../../../styles/components/js/selectStyle';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import DataTable from 'react-data-table-component';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import NoData from '../../../common/NoData';
import { NavLink } from 'react-router-dom';
import Dropdown from '../../../common/DropDown';
import {
  bulkApproveAuctions,
  bulkInvoiceAuctions,
  getAuctionCategories,
  getAuctions
} from './services/auctionService';
import { apiUrl } from '../../../../constants/global';
import { getOrganizationList } from '../../../../models/organization';
import { BiddersList } from './components/BiddersList';
import { Check, Download } from 'lucide-react';
import { toast } from 'react-toastify';
import { getLoggedUser } from '../../../../state/user';
import DateRangeSelector from '../../../common/DateRange';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

const user = getLoggedUser();

export class AuctionsListNew extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        type: '',
        category: '',
        status: '',
        client: '1',
        group: null,
        startDate: '',
        endDate: '',
      },
      categories: [],
      clients: [],
      groups: [],
      auctions: [],
      isloading: false,
      limit: 15,
      page: 1,
      total: 0,
      groupLoading: false,
      showBidders: false,
      bidders: [],
      selectedAction: null,
      selectedRows: [],
      selectedRowsFull: [],
      toggleCleared: false,
      processing: false,
      clearDate: null,
      zipLang: 'en',
      zipping: false,
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.downloadSelectedAsZip = this.downloadSelectedAsZip.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);
    const search = {
      type: params.get('type') || '',
      category: params.get('category') || '',
      client: params.get('client') || null,
      group: params.get('group') || null,
      status: params.get('status') || '',
      startDate: params.get('startDate') || '',
      endDate: params.get('endDate') || '',
    };
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;

    this.setState({ search, page, limit }, () => {
      this.getAllCategories();
      this.getAllAuctions();
      this.getAllGroups();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }

  async getAllAuctions() {
    this.setState({ isloading: true });
    let { limit, page } = this.state;
    let { type, category, client, group, status, startDate, endDate } = this.state.search;
    const q = {
      page: page,
      limit: limit,
    };

    if (type) q.type = type;
    if (category) q.category = category;
    if (client) q.client = client;
    if (group) q.group = group;
    if (status) q.status = status;
    if (startDate) q.startDate = startDate;
    if (endDate) q.endDate = endDate;

    // Update URL
    this.updateUrlQuery(q);

    try {
      const response = await getAuctions(q);
      if (response.success) {
        this.setState({
          auctions: response.data,
          total: response.meta.total,
        });
      }
    } catch (error) {
      console.error('Auction fetch failed:', error);
    } finally {
      this.setState({ isloading: false });
    }
  }

  async getAllCategories() {
    this.setState({ categoriesLoading: true });
    const response = await getAuctionCategories();
    if (response.success) {
      let data = response.data;
      const categories = data.map((item) => {
        return {
          value: item.id,
          label: item.category_name,
        };
      });
      this.setState({ categories, categoriesLoading: false });
    } else {
      this.setState({ categoriesLoading: false });
    }
  }

  async getAllOrganization() {
    const response = await getOrganizationList();
    let data = response.data;
    const clients = data.map((item) => {
      return {
        value: item.id,
        label: item.organization_name,
      };
    });
    this.setState({ clients });
  }

  async getAllGroups() {
    this.setState({ groupLoading: true });
    let { client } = this.state.search;
    let q = client ? `organization=${1}` : '';
    const response = await getGroupsList(q);
    if (response.success) {
      let data = response.data;
      const groups = data.map((item) => {
        return {
          value: item.id,
          label: item.group_name,
        };
      });
      this.setState({ groups, groupLoading: false });
    } else {
      this.setState({ groups: [], groupLoading: false });
    }
  }

  // Get action counts
  getActionCounts = () => {
    const { auctions, selectedRows } = this.state;
    return {
      approve: auctions.filter((a) => a.status === 'E' || a.status === 'N').length,
      invoice: auctions.filter((a) => a.status === 'E').length,
      download: auctions.filter((a) => a.status === 'E').length,
      selectedItems: selectedRows.length,
    };
  };

  // Check if row can be selected based on action
  isRowSelectable = (row) => {
    const { selectedAction } = this.state;
    if (!selectedAction) return false;

    if (selectedAction === 'approve') {
      return row.status === 'E' || row.status === 'N';
    }
    if (selectedAction === 'invoice_en' || selectedAction === 'invoice_ar') {
      return row.status === 'E';
    }
    if (selectedAction === 'download') {
      return row.status === 'E';
    }
    return false;
  };

  // Handle action selection
  handleActionChange = (action) => {
    this.setState({
      selectedAction: this.state.selectedAction === action ? null : action,
      selectedRows: [],
      selectedRowsFull: [],
      toggleCleared: !this.state.toggleCleared,
    });
  };

  // Handle row selection
  handleRowSelected = (state) => {
    const selectedIds = state.selectedRows.map((row) => row.id);
    this.setState({
      selectedRows: selectedIds,
      selectedRowsFull: state.selectedRows,
    });
  };

  // Handle confirmation
  handleConfirmation = async (type) => {
    const { selectedAction, selectedRows } = this.state;

    if (type === 'approve') {
      if (!selectedAction || selectedRows.length === 0) {
        toast.error('Please select at least one auction and an action.');
        return;
      }

      // Bulk ZIP download is handled separately (client-side), not via the API confirm flow
      if (selectedAction === 'download') {
        await this.downloadSelectedAsZip();
        return;
      }

      this.setState({ processing: true });

      try {
        let payload = {};
        let result = null;

        if (selectedAction === 'approve') {
          payload = { status: 'A', auctions_id: selectedRows };
          result = await bulkApproveAuctions(payload);
        } else if (selectedAction === 'invoice_en') {
          payload = { lang: 'en', auctions_id: selectedRows };
          result = await bulkInvoiceAuctions(payload);
        } else if (selectedAction === 'invoice_ar') {
          payload = { lang: 'ar', auctions_id: selectedRows };
          result = await bulkInvoiceAuctions(payload);
        }

        if (result?.success) {
          toast.success(`Successfully processed ${selectedRows.length} auctions.`);
        } else {
          toast.error(result?.message || 'Something went wrong.');
        }

        // Reset state and refresh after success
        this.setState({
          selectedRows: [],
          selectedRowsFull: [],
          selectedAction: null,
          toggleCleared: !this.state.toggleCleared,
        });

        this.getAllAuctions();
      } catch (error) {
        console.error('Bulk action failed:', error);
        toast.error('Failed to process bulk action. Please try again.');
      } finally {
        this.setState({ processing: false });
      }
    } else {
      // Cancel action
      this.setState({
        selectedRows: [],
        selectedRowsFull: [],
        selectedAction: null,
        toggleCleared: !this.state.toggleCleared,
      });
    }
  };

  // Bulk download selected auction invoices as a ZIP archive
  async downloadSelectedAsZip() {
    const { selectedRowsFull, zipLang } = this.state;

    if (selectedRowsFull.length === 0) {
      toast.error('Please select at least one auction to download.');
      return;
    }

    this.setState({ processing: true, zipping: true });

    try {
      const zip = new JSZip();
      let addedCount = 0;

      for (let row of selectedRowsFull) {
        if (row.status === 'E' && row.winner?.user_id) {
          const fileUrl = `${apiUrl}my_winnings/pdf?id=${row.winner.user_id}&group=${row.group}&lang=${zipLang}&auction=${row.id}`;

          try {
            const response = await fetch(fileUrl, {
              headers: { Authorization: `Bearer ${user.token}` },
            });
            if (response.ok) {
              const blob = await response.blob();
              zip.file(`auction_${row.id}_${row.winner?.username || row.winner.user_id}_${zipLang}.pdf`, blob);
              addedCount++;
            }
          } catch (err) {
            console.error(`Failed to fetch invoice for auction ${row.id}:`, err);
          }
        }
      }

      if (addedCount === 0) {
        toast.error('No invoices were available for the selected auctions.');
        return;
      }

      const content = await zip.generateAsync({ type: 'blob' });
      saveAs(content, `auctions_invoices_${zipLang}.zip`);
      toast.success(`Downloaded ${addedCount} invoice${addedCount > 1 ? 's' : ''} as ZIP.`);

      this.setState({
        selectedRows: [],
        selectedRowsFull: [],
        selectedAction: null,
        toggleCleared: !this.state.toggleCleared,
      });
    } catch (error) {
      console.error('ZIP download failed:', error);
      toast.error('Failed to generate ZIP file. Please try again.');
    } finally {
      this.setState({ processing: false, zipping: false });
    }
  }

  getColumns = () => {
    const isClient = user?.role === 'C' || user?.role === 'RS';
    return [
      {
        id: 1,
        name: 'MZAD ID',
        width: '110px',
        sortable: true,
        wrap: true,
        cell: (row) => <span className="highlight-table-value">MZADROP {row.id}</span>,
      },
      // ACTION COLUMN (hide for role C)
      ...(!isClient
        ? [
          {
            id: 2,
            name: i18n.t('action'),
            width: '110px',
            wrap: true,
            center: true,
            cell: (row) => {
              const detailPath = `/auction/edit/${row.id}`;
              return (
                <div className="action-buttons">
                  <ActionButton key="edit" label="edit" to={detailPath} />
                </div>
              );
            },
          },
        ]
        : []),
      {
        id: 3,
        name: i18n.t('bid_count'),
        width: '110px',
        sortable: true,
        wrap: true,
        cell: (row) => (
          <button
            className="button1 button1-outline button1-action"
            disabled={row.bidders_count > 0 ? false : true}
            onClick={() => {
              this.setState({ showBidders: true, bidders: row.bidders });
            }}
          >
            {row.bidders_count}
          </button>
        ),
      },
      {
        id: 4,
        name: i18n.t('title'),
        minWidth: '140px',
        cell: (row) => <span className="highlight-table-value-secondary">{row.title}</span>,
      },
      {
        id: 5,
        name: i18n.t('price'),
        width: '100px',
        cell: (row) => <span>{row.start_amount}</span>,
        wrap: true,
        right: true,
      },
      {
        id: 6,
        name: i18n.t('increment_amount'),
        width: '100px',
        cell: (row) => <span>{row.bid_increment}</span>,
        wrap: true,
        right: true,
      },
      {
        id: 7,
        name: i18n.t('start_date'),
        width: '120px',
        cell: (row) => <span>{formatDate(row.start_date)}</span>,
        wrap: true,
      },
      {
        id: 8,
        name: i18n.t('end_date'),
        width: '120px',
        cell: (row) => <span>{formatDate(row.end_date)}</span>,
        wrap: true,
      },
      {
        id: 9,
        name: i18n.t('status'),
        cell: (row) => <StatusBadge status={AUCTION_STATUS[row.status]} />,
        wrap: true,
      },
      // BIDDER INVOICE COLUMN (hide for role C)
      ...([
        {
          id: 10,
          name: `${i18n.t('invoice')} ${i18n.t('bidder')}`,
          button: true,
          width: '120px',
          wrap: true,
          cell: (row) =>
            row.status === 'E' && (
              <div>
                <a
                  className="btn-new btn-new--action-b"
                  href={`${apiUrl}my_winnings/pdf?id=${row.winner?.user_id}&group=${row.group}&lang=ar&auction=${row.id}`}
                  target="_new"
                >
                  {i18n.t('Ar')}
                </a>
                &nbsp;
                <a
                  className="btn-new btn-new--action-b"
                  href={`${apiUrl}my_winnings/pdf?id=${row.winner?.user_id}&group=${row.group}&lang=en&auction=${row.id}`}
                  target="_new"
                >
                  {i18n.t('En')}
                </a>
              </div>
            ),
        },
      ]
      ),
      // CLIENT INVOICE COLUMN (hide for role C)
      ...(
        [
          {
            id: 11,
            name: `${i18n.t('invoice')} ${i18n.t('client')}`,
            button: true,
            width: '120px',
            wrap: true,
            cell: (row) =>
              row.status === 'E' && (
                <div>
                  <a
                    className="btn-new btn-new--action-c"
                    href={`${apiUrl}my_winnings/pdf?id=${row.winner?.user_id}&group=${row.group}&lang=ar&is_client=1&auction=${row.id}`}
                    target="_new"
                  >
                    {i18n.t('Ar')}
                  </a>
                  &nbsp;
                  <a
                    className="btn-new btn-new--action-c"
                    href={`${apiUrl}my_winnings/pdf?id=${row.winner?.user_id}&group=${row.group}&lang=en&is_client=1&auction=${row.id}`}
                    target="_new"
                  >
                    {i18n.t('En')}
                  </a>
                </div>
              ),
          },
        ]),
    ];
  };

  handleSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      (prevState) => {
        const updatedSearch = {
          ...prevState.search,
          [name]: value,
          // Clear group when client changes or is cleared
          ...(name === 'client' && { group: null }),
        };
        return { search: updatedSearch };
      },
      () => {
        if (name === 'client' && value) {
          this.getAllGroups();
        }
      }
    );
  };

  handleSearch = () => {
    this.setState({ page: 1 }, () => {
      this.getAllAuctions();
    });
  };

  handleClear = () => {
    const defaultSearch = {
      type: '',
      category: '',
      status: '',
      client: null,
      group: null,
      startDate: '',
      endDate: '',
    };

    this.setState(
      {
        search: defaultSearch,
        page: 1,
        selectedRows: [],
        selectedRowsFull: [],
        clearDate: Date.now(), // Trigger clear in DateRangeSelector
      },
      () => {
        this.getAllAuctions();
      }
    );
  };

  // Date range change handler
  handleDateRangeChange = (dateRange) => {
    this.setState(
      (prevState) => ({
        search: {
          ...prevState.search,
          startDate: dateRange.startDate || '',
          endDate: dateRange.endDate || '',
        },
        page: 1,
      }),
      () => {
        this.getAllAuctions();
      }
    );
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.getAllAuctions();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.getAllAuctions();
    });
  };

  render() {
    const {
      groups,
      auctions,
      clients,
      categories,
      showBidders,
      bidders,
      selectedAction,
      processing,
      zipping,
      zipLang,
    } = this.state;
    const actionCounts = this.getActionCounts();
    const isClient = user?.role === 'C';

    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t('auctions')}
          subtitle={i18n.t('manage_auctions_bidders_and_financial_records')}
        />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    {!isClient && (
                      <>
                        <FilterSection
                          loading={this.state.isloading}
                          onSearch={this.handleSearch}
                          onClear={this.handleClear}
                        >
                          {/* Type Dropdown */}
                          <Dropdown
                            name="type"
                            value={this.state.search.type}
                            onChange={this.handleSearchChange}
                            placeholder={i18n.t('auction_type')}
                            empty={i18n.t('select_type')}
                            options={[
                              { value: 'active', label: i18n.t('active') },
                              { value: 'previous', label: i18n.t('previous') },
                              { value: 'upcoming', label: i18n.t('upcoming') },
                              { value: 'direct', label: i18n.t('direct') },
                            ]}
                          />
                          {/* Category Type Dropdown */}
                          <Dropdown
                            name="category"
                            value={this.state.search.category}
                            onChange={this.handleSearchChange}
                            placeholder={i18n.t('category')}
                            empty={i18n.t('select_category')}
                            options={categories}
                          />


                          {/* Group Dropdown */}
                          <div className="react-select-wrapper">
                            <Select
                              options={groups}
                              value={
                                groups.find((c) => c.value === this.state.search.group) || null
                              }
                              onChange={(selectedOption) => {
                                this.setState((prevState) => ({
                                  search: {
                                    ...prevState.search,
                                    group: selectedOption ? selectedOption.value : null,
                                  },
                                }));
                              }}
                              name="group"
                              styles={selectStyles}
                              menuPlacement="auto"
                              menuPortalTarget={document.body}
                              placeholder={i18n.t('search_group')}
                              isLoading={this.state.groupLoading}
                              isDisabled={this.state.groupLoading}
                              isClearable
                            />
                            <label className="react-select-label">{i18n.t('group')}</label>
                          </div>

                          {/* Start Date */}
                          <div className="select-wrapper floating-label-wrapper">
                            <input
                              id="startDate"
                              type="date"
                              name="startDate"
                              value={this.state.search.startDate || ''}
                              onChange={this.handleSearchChange}
                              className="filter-base floating-input"
                              placeholder=" "
                            />
                            <label htmlFor="startDate" className="floating-label">
                              {i18n.t('start_date')}
                            </label>
                          </div>

                          {/* End Date */}
                          <div className="select-wrapper floating-label-wrapper">
                            <input
                              id="endDate"
                              type="date"
                              name="endDate"
                              value={this.state.search.endDate || ''}
                              onChange={this.handleSearchChange}
                              className="filter-base floating-input"
                              placeholder=" "
                            />
                            <label htmlFor="endDate" className="floating-label">
                              {i18n.t('end_date')}
                            </label>
                          </div>

                          {/* Date Range Selector */}
                          <DateRangeSelector
                            onChange={this.handleDateRangeChange}
                            clearTrigger={this.state.clearDate}
                          />
                        </FilterSection>

                        {/* Bulk Action Selector */}

                        <ActionSelector
                          selectedAction={selectedAction}
                          onActionChange={this.handleActionChange}
                          actionCounts={actionCounts}
                          onProceed={() => this.handleConfirmation('approve')}
                          onCancel={() => this.handleConfirmation('cancel')}
                          loading={processing || zipping}
                          zipLang={zipLang}
                          onZipLangChange={(lang) => this.setState({ zipLang: lang })}
                        />
                      </>
                    )}

                    <div className="Data-Listing">
                      {this.state.isloading ? (
                        <TableSkeleton columns={10} rows={10} />
                      ) : this.state.auctions.length ? (
                        <DataTable
                          responsive={true}
                          columns={this.getColumns()}
                          data={auctions}
                          customStyles={tableStyles}
                          highlightOnHover
                          selectableRows={selectedAction !== null}
                          selectableRowsHighlight
                          selectableRowDisabled={(row) => !this.isRowSelectable(row)}
                          onSelectedRowsChange={this.handleRowSelected}
                          clearSelectedRows={this.state.toggleCleared}
                          pagination
                          paginationServer
                          paginationTotalRows={this.state.total}
                          paginationPerPage={this.state.limit}
                          paginationDefaultPage={this.state.page}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: i18n.t('rows_per_page'),
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                        />
                      ) : (
                        <NoData
                          message={i18n.t('no_auctions_available')}
                          actionText={i18n.t('refresh')}
                          onAction={this.getAllAuctions.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <BiddersList
          show={showBidders}
          bidders={bidders}
          onClose={() => this.setState({ showBidders: false })}
        />
      </React.Fragment>
    );
  }
}

const ActionButton = ({
  label,
  icon,
  to,
  variant = 'button1-primary',
  onClick,
  active = false,
}) => {
  if (to) {
    return (
      <NavLink to={to} className={`button1 ${variant} button1-action`}>
        {icon} {i18n.t(label)}
      </NavLink>
    );
  }

  return (
    <button
      disabled={active}
      className={`button1 button1-primary button1-action`}
      onClick={onClick}
    >
      {icon} {i18n.t(label)}
    </button>
  );
};

const ActionSelector = ({
  selectedAction,
  onActionChange,
  actionCounts,
  onProceed,
  onCancel,
  loading,
  zipLang,
  onZipLangChange,
}) => {
  const userRole = getLoggedUser()?.role;

  const actions = [
    { id: 'approve', label: i18n.t('approve'), count: actionCounts.approve },
    // {
    //   id: 'invoice_en',
    //   label: `${i18n.t('invoice')} ${i18n.t('En')}`,
    //   count: actionCounts.invoice,
    // },
    // {
    //   id: 'invoice_ar',
    //   label: `${i18n.t('invoice')} ${i18n.t('Ar')}`,
    //   count: actionCounts.invoice,
    // },
    {
      id: 'download',
      label: i18n.t('download_zip') || 'Download ZIP',
      count: actionCounts.download,
      // icon: <Download size={14} strokeWidth={2.5} />,
    },
  ].filter((action) => !(userRole === 'RS' && action.id === 'approve'));

  return (
    <div className="bulk-action-selector">
      <div className="action-title">{i18n.t('select_bulk_action')}</div>

      <div className="action-content">
        <div className="action-buttons">
          {actions.map((action) => {
            const isActive = selectedAction === action.id;
            const isDisabled = action.count === 0;
            return (
              <button
                key={action.id}
                onClick={() => onActionChange(action.id)}
                className={`action-select-btn ${isActive ? 'active' : ''}`}
                disabled={isDisabled}
                style={{
                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                  opacity: isDisabled ? 0.6 : 1,
                }}
              >
                <span className="radio-icon">
                  {isActive ? <Check size={14} strokeWidth={3} /> : action.icon || null}
                </span>
                <span className="action-label">{action.label}</span>
              </button>
            );
          })}
        </div>

        {selectedAction === 'download' && (
          <div className="zip-lang-selector" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginTop: '0.5rem' }}>
            <span className="action-label" style={{ fontSize: '0.85rem' }}>
              {i18n.t('language') || 'Language'}:
            </span>
            <select
              className="filter-base"
              value={zipLang}
              onChange={(e) => onZipLangChange(e.target.value)}
              style={{ width: 'auto', padding: '0.25rem 0.5rem' }}
            >
              <option value="en">{i18n.t('En')}</option>
              <option value="ar">{i18n.t('Ar')}</option>
            </select>
          </div>
        )}

        <div className="action-controls">
          <button
            className="button1 button1-gray"
            onClick={onCancel}
            disabled={!selectedAction || loading}
          >
            {i18n.t('cancel')}
          </button>
          <button
            className="button1 button1-primary"
            onClick={onProceed}
            disabled={!actionCounts.selectedItems || loading}
          >
            {loading ? (
              <>
                {selectedAction === 'download' ? i18n.t('download') || 'Download' : i18n.t('process')}
                <span className="spinner" />
              </>
            ) : (
              <>
                {selectedAction === 'download' ? i18n.t('download') || 'Download' : i18n.t('process')}
                <span className="action-count">{actionCounts.selectedItems}</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};